import { observable, action } from 'mobx';

export class IdDetailDialog {
  // effect
  @observable effectFn = null;
  @action setEffect = (fn) => {
    this.effectFn = fn;
  }
}

export default new IdDetailDialog();
